// import components
import { Box, styled, TextField, TextFieldProps } from '@mui/material';
import type { Theme } from '@mui/material';

export const StyledMainDatePickerBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
}));

/** the field's own class for a value that sits on a muted day */
export const MUTED_VALUE_CLASS = 'muted-value';

// Note: we need to prevent max width due to DatePicker's selection area.
const withInputWidth = (width: string, theme: Theme) => ({
  '& .MuiInputAdornment-root': {
    marginLeft: 'auto'
  },
  '& .MuiInputBase-input': {
    width
  },
  // The value points at a muted day (see `shouldMuteDate`). Greyed rather
  // than red: it is a state to notice while picking, not a typing mistake, and
  // the screen says elsewhere what it means. The rule lives here rather than on
  // one of the two fields below, because the muted class is set on whichever
  // field the picker renders.
  [`&.${MUTED_VALUE_CLASS} .MuiInputBase-input`]: {
    color: theme.palette.text.disabled
  }
});

export const StyledCustomDatePickerTextField = styled(
  TextField
)<TextFieldProps>(({ theme }) => withInputWidth('75px', theme));

// The month picker spells its value out as "MMMM YYYY", which needs more room.
export const StyledMonthYearDatePickerTextField = styled(
  TextField
)<TextFieldProps>(({ theme }) => withInputWidth('130px', theme));

/** a muted day in the calendar: light grey, but still selectable */
export const mutedDaySx = {
  color: 'text.disabled',
  // MUI paints the selected day in the primary colour; a muted day that is also
  // the current value has to keep reading as muted
  '&.Mui-selected': {
    color: 'text.disabled',
    backgroundColor: 'action.selected',
    '&:hover, &:focus': { backgroundColor: 'action.selected' }
  }
} as const;
